import axios from "axios";
import { useQuery } from "@tanstack/react-query";
import { API_BASE_RELATIVE_PATH, API_BASE_PATH } from "../Config/Config";
import { getUserDetails } from "../utils/userDetailsUtils";

const fetchCurrentExecution = async (filters = {}) => {
  const user = getUserDetails();

  const params = new URLSearchParams({
    action: "getCurrentExecutions",
    companyid: user.companyid,
  });

  if (filters.fromDate) params.append("fromDate", filters.fromDate);
  if (filters.toDate) params.append("toDate", filters.toDate);
  if (Array.isArray(filters.runBy)) {
    filters.runBy.forEach((v) => params.append("runBy", v));
  }

  if (filters.browser && filters.browser !== "All") {
    params.append("browser", filters.browser);
  }

  if (Array.isArray(filters.status)) {
    filters.status.forEach((v) => params.append("status", v));
  }

  if (filters.application && filters.application !== "All") {
    params.append("application", filters.application);
  }
  if (Array.isArray(filters.module)) {
    filters.module.forEach((v) => params.append("module", v));
  }
  if (filters.testCase) {
    params.append("testCase", filters.testCase);
  }

  params.append("page", "1");
  params.append("pageSize", "50");

  const response = await axios.get(
    `${API_BASE_PATH}${API_BASE_RELATIVE_PATH}?${params.toString()}`,
  );

  return response.data;
};

const useCurrentExecutionQuery = (filters = {}) => {
  return useQuery({
    queryKey: ["currentExe", filters],
    queryFn: () => fetchCurrentExecution(filters),
    retry: true,
    cacheTime: 0,
    refetchInterval: false,
    refetchIntervalInBackground: false,
    staleTime: 0,
  });
};

export default useCurrentExecutionQuery;
